import { render, staticRenderFns } from "./ResultadoExportacao.vue?vue&type=template&id=687e35ab&scoped=true"
import script from "./ResultadoExportacao.vue?vue&type=script&setup=true&lang=js"
export * from "./ResultadoExportacao.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687e35ab",
  null
  
)

export default component.exports